(function () {
  function initOgcProductExperience() {
    var accordion = document.getElementById('widgetsAccordion');

    if (accordion) {
      var items = accordion.querySelectorAll('.widget-item');
      var graphics = document.querySelectorAll('.widget-graphic');

      graphics.forEach(function (g) {
        var key = g.getAttribute('data-widget');
        var item = accordion.querySelector('.widget-item[data-target="' + key + '"]');
        if (!item || item.querySelector('.widget-graphic-mobile')) return;

        var clone = g.cloneNode(true);
        clone.className = 'widget-graphic-mobile';
        clone.setAttribute('data-widget', key);
        item.querySelector('.widget-item-body').appendChild(clone);
      });

      function activateGraphic(key) {
        graphics.forEach(function (g) {
          g.classList.toggle('active', g.dataset.widget === key);
        });
      }

      items.forEach(function (item) {
        var btn = item.querySelector('.widget-item-head');
        var key = item.dataset.target;

        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');

          items.forEach(function (i) {
            i.classList.remove('open');
            i.querySelector('.widget-item-head').setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            item.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
            activateGraphic(key);
          }
        });
      });
    }

    var testimonial = document.querySelector('.testimonial-carousel');
    if (testimonial) {
      var track = testimonial.querySelector('.testimonial-scroll');
      var prev = testimonial.querySelector('.tcard-nav.prev');
      var next = testimonial.querySelector('.tcard-nav.next');

      if (track) {
        if (!track.dataset.cloned) {
          track.innerHTML += track.innerHTML;
          track.dataset.cloned = 'true';
        }

        if (prev) prev.removeAttribute('disabled');
        if (next) next.removeAttribute('disabled');

        var speed = 0.25;
        var paused = false;
        var manualScrollUntil = 0;

        function halfWidth() {
          return track.scrollWidth / 2;
        }

        function normalizeScroll() {
          var half = halfWidth();
          if (track.scrollLeft >= half) track.scrollLeft -= half;
          if (track.scrollLeft < 0) track.scrollLeft += half;
        }

        function scrollAmount() {
          var card = track.querySelector('.tcard');
          return card ? card.offsetWidth + 20 : track.clientWidth * 0.8;
        }

        function smoothMove(distance) {
          manualScrollUntil = Date.now() + 700;
          track.scrollBy({ left: distance, behavior: 'smooth' });
          setTimeout(normalizeScroll, 750);
        }

        if (prev) prev.addEventListener('click', function () {
          smoothMove(-scrollAmount());
        });

        if (next) next.addEventListener('click', function () {
          smoothMove(scrollAmount());
        });

        track.addEventListener('mouseenter', function () {
          paused = true;
        });

        track.addEventListener('mouseleave', function () {
          paused = false;
        });

        [prev, next].forEach(function (btn) {
          if (!btn) return;
          btn.addEventListener('mouseenter', function () { paused = true; });
          btn.addEventListener('mouseleave', function () { paused = false; });
        });

        function animate() {
          var now = Date.now();

          if (!paused && now > manualScrollUntil) {
            track.scrollLeft += speed;
            normalizeScroll();
          }

          requestAnimationFrame(animate);
        }

        animate();
      }
    }

    var videoCarousel = document.querySelector('.video-carousel');
    if (videoCarousel) {
      var videoTrack = videoCarousel.querySelector('.video-row');
      var videoPrev = videoCarousel.querySelector('.vcard-nav.prev');
      var videoNext = videoCarousel.querySelector('.vcard-nav.next');

      function videoScrollAmount() {
        var item = videoTrack.querySelector('.video-item');
        return item ? item.offsetWidth + 24 : videoTrack.clientWidth * 0.8;
      }

      if (videoPrev) videoPrev.addEventListener('click', function () {
        videoTrack.scrollBy({ left: -videoScrollAmount(), behavior: 'smooth' });
      });

      if (videoNext) videoNext.addEventListener('click', function () {
        videoTrack.scrollBy({ left: videoScrollAmount(), behavior: 'smooth' });
      });
    }

    document.addEventListener('click', function (event) {
    var card = event.target.closest('.video-card[data-yt]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    var id = card.dataset.yt;
    if (!id) return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
    iframe.title = 'One Good Card video';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    card.replaceChildren(iframe);
    });

    document.querySelectorAll('.ogc-shop-swatch[data-variant-image]').forEach(function (swatch) {
      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var card = swatch.closest('.ogc-shop-card');
        if (!card) return;

        var image = card.querySelector('.ogc-shop-image');
        var newImage = swatch.getAttribute('data-variant-image');

        if (image && newImage) {
          image.src = newImage;
          image.srcset = '';
        }

        card.querySelectorAll('.ogc-shop-swatch').forEach(function (item) {
          item.classList.remove('active');
        });

        swatch.classList.add('active');
      });
    });

    if (window.lucide) {
      window.lucide.createIcons();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOgcProductExperience);
  } else {
    initOgcProductExperience();
  }
})();